import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/auth.context";

// Simplified attendance access guard for debugging
export function AttendanceAccessGuard() {
  const { user } = useAuth();
  
  console.log("🔍 AttendanceAccessGuard - User:", user);
  console.log("🔍 AttendanceAccessGuard - User role:", user?.role);
  console.log("🔍 AttendanceAccessGuard - User leadershipRole:", user?.leadershipRole);
  console.log("🔍 AttendanceAccessGuard - User isGroupLeader:", user?.isGroupLeader);
  console.log("🔍 AttendanceAccessGuard - User isAdmin:", user?.isAdmin);
  
  if (!user) {
    console.log("❌ No user found, redirecting to login");
    return <Navigate to="/login" replace />;
  }
  
  // For single group setup, allow all authenticated users to access attendance
  console.log("✅ User authenticated, allowing access to attendance");
  return <Outlet />;
}
